import React, { useEffect, useRef, useState } from 'react';
import { useBettingTimer } from '../betting/hooks/useBettingTimer';

export default function ChartInfoBar({ dataChart }) {
  // 使用倒计时Hook
  const { getCountdownData } = useBettingTimer();

  return (
    <div className="flex items-center justify-between h-full px-2 sm:px-6 select-none">
      <div className="flex flex-col justify-center">
        <span className="text-white font-bold text-[16px] leading-tight ">Pred CD</span>
      </div>
      <div className="flex items-center gap-3">
        {[5, 15, 30].map((periodMinutes, idx) => {
          // 对应下注卡片的主色
          const colorMap = {
            5: { bg: 'bg-blue-500/30', border: 'border-blue-400' },
            15: { bg: 'bg-purple-500/30', border: 'border-purple-400' },
            30: { bg: 'bg-amber-500/30', border: 'border-amber-400' }
          };
          const countdownData = getCountdownData(periodMinutes);
          const color = colorMap[periodMinutes] || colorMap[5];
          
          return (
            <div key={periodMinutes} className="flex flex-row items-stretch">
              <div className={`${color.bg} text-white text-xs flex items-center justify-center px-2 h-6 rounded-l-lg border ${color.border}`}>
                {periodMinutes}M
              </div>
              <div className={`bg-[#23253b] text-white text-xs flex items-center justify-center px-2 h-6 rounded-r-lg border -ml-1 tracking-normal ${color.border} ${countdownData.countdownColorClass}`} style={{minWidth: '60px'}}>
                {countdownData.formattedTime}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
